import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TenantLicense } from '../../models/tenant-license.model';
import { TenantLicenseService } from '../../services/tenant-license.service';

@Component({
  selector: 'iw-user-grid',
  templateUrl: './iw-user-grid.component.html',
})
export class IwUserGridComponent implements OnInit {
  @Input()
  public tenants: TenantLicense[] | undefined = [];
  @Output()
  public changeDisplay: EventEmitter<TenantLicense> = new EventEmitter<TenantLicense>();
  constructor(
    public readonly tenantLicenseService: TenantLicenseService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.tenants = this.tenantLicenseService.getTenant();
  }

  public updateTenant(tenant: TenantLicense): void {
    this.changeDisplay.emit(tenant);
  }

  public deleteTenant(tenant: TenantLicense): any {
    this.confirmationService.confirm({
      message: this.translate.instant(
        'Do you really want to delete this Client?',
      ),
      header: this.translate.instant('Confirmation'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteTenantErros(tenant);
      },
      reject: () => {
        return;
      },
    });
  }

  private deleteTenantErros(tenant: TenantLicense): void {
    this.tenantLicenseService.deleteTenant(tenant.tenant).subscribe(
      (res) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Success Message'),
            detail: this.translate.instant('Client deleted'),
          });
        }, 1000);
        this.tenants = this.tenants ? this.tenants.filter(
          (u: TenantLicense) => u !== tenant,
        ) : undefined;
      },
      (err) => {
        setTimeout((): void => {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('Error Message'),
            // tslint:disable-next-line: max-line-length
            detail: this.translate.instant('Errors occurred - This tenant still has users or options that need to be removed, before you can continue'),
          });
        }, 1000);
      },
    );
  }
}
